/**
 * Resolves content image URLs for web (relative `/…` → absolute origin URL).
 * Contentful CDN URLs (`https://…`) pass through unchanged.
 */
export function resolveBloomUniversalImageUrl(
  url: string | undefined,
): string | undefined {
  if (!url?.trim()) {
    return undefined;
  }
  const trimmed = url.trim();
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
    return trimmed;
  }
  if (trimmed.startsWith('//')) {
    return `https:${trimmed}`;
  }
  if (typeof window !== 'undefined' && window.location?.origin) {
    const path = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
    return `${window.location.origin}${path}`;
  }
  return trimmed;
}
